import kyDefault, { type KyInstance } from 'ky';
import { getLoginRedirectPath, useAuthStore } from '../stores/auth.store';

let isRefreshing = false;

export const api: KyInstance = kyDefault.create({
  prefixUrl: '/api/v1',
  hooks: {
    beforeRequest: [
      (request) => {
        const token = useAuthStore.getState().token;
        if (token) {
          request.headers.set('Authorization', `Bearer ${token}`);
        }
      },
    ],
    afterResponse: [
      async (request, _options, response) => {
        if (response.status !== 401) return response;
        if (isRefreshing) {
          const redirectPath = getLoginRedirectPath(useAuthStore.getState().licensingAuthorities);
          useAuthStore.getState().clearSession();
          window.location.href = redirectPath;
          return response;
        }
        isRefreshing = true;
        try {
          const refreshRes = await kyDefault.post('/api/v1/auth/refresh', {
            credentials: 'include',
          });
          const data = (await refreshRes.json()) as {
            accessToken: string;
            user: {
              id: string;
              email: string;
              name: string;
              avatarUrl?: string | null;
              licensingAuthorities?: string[];
            };
            permissions: string[];
          };
          useAuthStore.getState().setSession(
            {
              id: data.user.id,
              email: data.user.email,
              name: data.user.name,
              avatarUrl: data.user.avatarUrl,
            },
            data.permissions,
            data.accessToken,
            false,
            data.user.licensingAuthorities ?? [],
          );
          request.headers.set('Authorization', `Bearer ${data.accessToken}`);
          return kyDefault(request);
        } catch {
          const redirectPath = getLoginRedirectPath(useAuthStore.getState().licensingAuthorities);
          useAuthStore.getState().clearSession();
          window.location.href = redirectPath;
          return response;
        } finally {
          isRefreshing = false;
        }
      },
    ],
  },
});
